<section class="products-grid" *ngIf="products && products.length > 0">

    <header class="products-grid__header" *ngIf="hasHeader">
        <div class="products-grid__header-inner">
            <span class="products-grid__overline" *ngIf="sectionOverline">{{ sectionOverline }}</span>
            <h2 class="products-grid__title" *ngIf="sectionTitle">{{ sectionTitle }}</h2>
            <p class="products-grid__description" *ngIf="sectionDescription">{{ sectionDescription }}</p>
            <div class="products-grid__meta" *ngIf="showTrustMeta">
                <span class="products-grid__meta-item">
                    <strong>{{ itemCount }}</strong> {{ itemLabel }}
                </span>
                <span class="products-grid__meta-divider" aria-hidden="true">·</span>
                <span class="products-grid__meta-item products-grid__meta-rating">
                    <span class="products-grid__stars" aria-hidden="true">★</span>
                    <strong>{{ trustRating }}</strong>
                    <span>· {{ trustReviewCount | number }} reviews on Tripadvisor</span>
                </span>
            </div>
        </div>
    </header>

    <div class="products-grid__wrapper" [class.products-grid__wrapper--compact]="isCompact">
        <article
            class="products-grid__item"
            *ngFor="let product of products; let i = index; trackBy: trackById"
            [class.products-grid__item--featured]="showFeatured && i === 0">

            <span class="products-grid__ribbon" *ngIf="showFeatured && i === 0">{{ featuredLabel }}</span>

            <app-product-card [data]="product"></app-product-card>
        </article>
    </div>

</section>
